import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=1d47c6de&scoped=true"
import script from "./Preferences.vue?vue&type=script&lang=js"
export * from "./Preferences.vue?vue&type=script&lang=js"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=1d47c6de&prod&lang=scss&scoped=true"
import style1 from "./Preferences.vue?vue&type=style&index=1&id=1d47c6de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d47c6de",
  null
  
)

export default component.exports